export class CompareModeChangedEventArgs {
  isCompareMode;
  constructor(isCompareMode) {
    this.isCompareMode = isCompareMode;
  }
}
